import { useState } from 'react';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const displayTestimonials = testimonials.slice(0, 5);
  const mainTestimonial = displayTestimonials[activeIndex];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-6 h-6 flex items-center justify-center bg-accent-100 rounded">
              <i className="ri-double-quotes-l text-accent-500 text-xs"></i>
            </span>
            <span className="text-xs font-medium text-accent-600 uppercase tracking-wide">用户口碑</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            读者真实评价
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="md:col-span-1 flex flex-col gap-5">
            {displayTestimonials.slice(0, 2).map((t, i) => (
              <div
                key={t.id}
                onClick={() => setActiveIndex(i)}
                className={`p-5 rounded-lg cursor-pointer transition-all duration-300 ${
                  activeIndex === i
                    ? 'bg-background-50 ring-2 ring-primary-300'
                    : 'bg-background-50 hover:bg-background-200/50'
                }`}
              >
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={t.avatar}
                    alt={t.userName}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{t.userName}</div>
                    <div className="text-xs text-foreground-400">{t.role}</div>
                  </div>
                </div>
                <div className="flex gap-0.5 mb-2">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <span key={j} className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-400 text-xs"></i>
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{t.content}</p>
              </div>
            ))}
          </div>

          <div className="md:col-span-2">
            {mainTestimonial && (
              <div className="relative rounded-lg overflow-hidden h-full min-h-[360px]">
                <div className="absolute inset-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cozy%20reading%20scene%20person%20reading%20comics%20on%20tablet%20warm%20indoor%20lighting%20comfortable%20cafe%20atmosphere%20soft%20bokeh%20background%20relaxed%20vibe&width=800&height=600&seq=testimonial-featured&orientation=landscape"
                    alt="读者评价"
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/90 via-foreground-900/40 to-transparent"></div>
                </div>
                <div className="relative h-full flex flex-col justify-end p-8">
                  <div className="flex gap-0.5 mb-3">
                    {Array.from({ length: mainTestimonial.rating }).map((_, j) => (
                      <span key={j} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-accent-400"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-base md:text-lg text-background-50 leading-relaxed mb-4">
                    &ldquo;{mainTestimonial.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <img
                      src={mainTestimonial.avatar}
                      alt={mainTestimonial.userName}
                      className="w-10 h-10 rounded-full object-cover ring-2 ring-background-50/30"
                    />
                    <div>
                      <div className="text-sm font-semibold text-background-50">{mainTestimonial.userName}</div>
                      <div className="text-xs text-background-50/60">{mainTestimonial.role}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}